import Page from '../../page';
import ListAsyncManager,  { AsyncListManagerEvent } from "../../../helpers/asyncListManager/AsyncListManager";

export default class NewsList extends Page {

    constructor(...args) {
        super(...args);

        bindAll( this, [
            '_clickLoadMore',
        ]);

        this._retrieveDOM();
        this._initTls();
    }

    _retrieveDOM() {
        this.dom.views = {};

        this.dom.views.btnLoadMore = this.dom.page.querySelector( '.js-load-more' );
        this.dom.views.results = this.dom.page.querySelector('.js-news-list');
    }

    init() {
        super.init();

        this._action = 'bbi_news_get_posts_ajax';
        this._ALM = new ListAsyncManager( this._action, this.dom.views.btnLoadMore );
        this._locked = false;
    }

    bind() {
        super.bind();

        // Click button "load more"
        if( this.dom.views.btnLoadMore )
            this.dom.views.btnLoadMore.addEventListener( 'click', this._clickLoadMore );

        // Data receive
        this._ALM.on( AsyncListManagerEvent.UPDATED, ( xhr ) => {
            this._injectData(xhr);
        } );
    }

    /**
     * Called when user click on button "load more"
     * @param {Event} event - Click event
     * @private
     */
    _clickLoadMore( event ) {

        if( this._locked == false ) {
            this._locked = true;
            this._ALM.loadMore( event );
        }
    }

    /**
     * Called when ajax request succeeded ( request for new news )
     * @param {JSON} xhr - Request's response
     * @private
     */
    _injectData( xhr ) {
        this._locked = false;

        // Check if there is result
        if(xhr.data.has_results == false) {
            this._hideLoadMore();
        } else {

            // Check if there is other data to load
            if(xhr.data.load_more == true)
                this._showLoadMore();
            else
                this._hideLoadMore();

            // Insert new items
            if(xhr.data.page == 1) {
                this.dom.views.results.innerHTML = xhr.data.posts_html;
            } else {
                this.dom.views.results.insertAdjacentHTML( 'beforeend', xhr.data.posts_html );
            }

            // Display animation for new items
            this.newItems = document.querySelectorAll( '.to-animate' );
            for( let i = 0, j = this.newItems.length; i < j; i++ )
            {
                let delay = i * 110;
                this._animateResult(i, delay);
            }
        }
    }

    /**
     * Hide button load more
     * @private
     */
    _hideLoadMore() {
        if( this.dom.views.btnLoadMore )
            this.dom.views.btnLoadMore.classList.add('hidden');
    }

    /**
     * Show button load more
     * @private
     */
    _showLoadMore() {
        if( this.dom.views.btnLoadMore )
            this.dom.views.btnLoadMore.classList.remove('hidden');
    }

    /**
     * Display animation for new items to show
     * @param {Number} index - Target item to show
     * @param {Number} delay - Interval time between the animation of the elements
     * @private
     */
    _animateResult( index, delay ) {
        setTimeout(() => {
            this.newItems[ index ].classList.remove('to-animate');
        }, delay);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/news/list/news-list.js